import { ElementType } from 'react';

import {
  RiGithubFill,
  RiGroupFill,
  RiMailFill,
  RiQuestionFill,
  RiUserFill,
  RiDashboardFill,
  RiGlobalFill,
  RiFileTextFill,
  RiFolderAddFill,
  RiSlackFill,
  RiShapesFill,
  RiMessage2Fill,
  RiAlertFill,
} from '@remixicon/react';

import {
  LeanIXIcon,
  ConfluenceIcon,
  JiraIcon,
  BrokenImageIcon,
  CatalogIcon,
  ComponentIcon,
  TemplateIcon,
  TechdocsIcon,
  search,
} from '../assets/Icons';

type IconType = ElementType;

interface IconMappingData {
  key: string;
  label: string;
  icon: IconType;
}

export type IconMapping = {
  [key: string]: IconType;
};

export type IconLabelMapping = {
  [key: string]: string;
};

export const linkSuggestedIcons = [
  {
    value: 'jira',
    label: 'Jira',
    Icon: JiraIcon,
  },
  {
    value: 'confluence',
    label: 'Confluence',
    Icon: ConfluenceIcon,
  },
  {
    value: 'leanix',
    label: 'Lean IX',
    Icon: LeanIXIcon,
  },
  {
    value: 'slack',
    label: 'Slack',
    Icon: RiSlackFill,
  },
  {
    value: 'contact',
    label: 'Contact',
    Icon: RiUserFill,
  },
];

export const iconMappingData: IconMappingData[] = [
  {
    key: 'brokenImage',
    label: 'Broken Image',
    icon: BrokenImageIcon,
  },
  {
    key: 'catalog',
    label: 'Catalog',
    icon: CatalogIcon,
  },
  {
    key: 'chat',
    label: 'Chat',
    icon: RiMessage2Fill,
  },
  {
    key: 'component',
    label: 'Component',
    icon: ComponentIcon,
  },
  {
    key: 'confluence',
    label: 'Confluence',
    icon: ConfluenceIcon,
  },
  {
    key: 'contact',
    label: 'Contact',
    icon: RiUserFill,
  },
  {
    key: 'dashboard',
    label: 'Dashboard',
    icon: RiDashboardFill,
  },
  {
    key: 'default',
    label: 'Default',
    icon: RiGlobalFill,
  },
  {
    key: 'docs',
    label: 'Docs',
    icon: RiFileTextFill,
  },
  {
    key: 'email',
    label: 'Email',
    icon: RiMailFill,
  },
  {
    key: 'github',
    label: 'GitHub',
    icon: RiGithubFill,
  },
  {
    key: 'group',
    label: 'Group',
    icon: RiGroupFill,
  },
  {
    key: 'help',
    label: 'Help',
    icon: RiQuestionFill,
  },
  {
    key: 'jira',
    label: 'Jira',
    icon: JiraIcon,
  },
  {
    key: 'leanix',
    label: 'Lean IX',
    icon: LeanIXIcon,
  },
  {
    key: 'scaffolder',
    label: 'Scaffolder',
    icon: RiFolderAddFill,
  },
  {
    key: 'search',
    label: 'Search',
    icon: search,
  },
  {
    key: 'slack',
    label: 'Slack',
    icon: RiSlackFill,
  },
  {
    key: 'system',
    label: 'System',
    icon: RiShapesFill,
  },
  {
    key: 'techdocs',
    label: 'Techdocs',
    icon: TechdocsIcon,
  },
  {
    key: 'template',
    label: 'Template',
    icon: TemplateIcon,
  },
  {
    key: 'user',
    label: 'User',
    icon: RiUserFill,
  },
  {
    key: 'warning',
    label: 'Warning',
    icon: RiAlertFill,
  },
];

export const getIconMapping = () => {
  const iconMapObj: IconMapping = {};
  iconMappingData.forEach(item => {
    iconMapObj[item.key] = item.icon;
  });
  return iconMapObj;
};

export const getIconKeys = () => {
  return iconMappingData.map(item => ({
    label: item.key,
    value: item.key,
  }));
};
